import React from 'react';
import SkeletonKeyUpdates from 'components/Dashboard/KeyUpdates/SkeletonKeyUpdates';
import SkeletonConsultation from 'components/Dashboard/ConsultationsSection/SkeletonConsultation';
import SkeletonLegislation from 'components/Dashboard/Legislation/SkeletonLegislation';
import SkeletonParliamentary from 'components/Dashboard/ParliamentaryRecord/SkeletonParliamentary';
import SkeletonCalendarSearch from 'components/Dashboard/UpcomingEvents/SkeletonCalendarSearch';
import SkeletonInfluenceList from 'components/Dashboard/Influence/skeletons/SkeletonInfluenceList';
import SkeletonTwitter from 'components/Dashboard/SocialMedia/SkeletonTwitter';

const ListSkeleton = ({ sectionName }) => {
  switch (sectionName) {
    case 'KeyUpdates':
    case 'PriorityUpdates':
      return <SkeletonKeyUpdates />;
    case 'Consultations':
      return <SkeletonConsultation />;
    case 'Legislation':
      return <SkeletonLegislation />;
    case 'ParliamentLive':
      return <SkeletonConsultation />;
    case 'ParliamentaryRecord':
      return <SkeletonParliamentary />;
    case 'UpcomingEvents':
      return <SkeletonCalendarSearch />;
    case 'Influence':
      return <SkeletonInfluenceList influencePage={false} />;
    case 'SocialMedia':
      return <SkeletonTwitter />;
    default:
      return <SkeletonKeyUpdates />;
  }
};

export default ListSkeleton;
